import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword, OAuthProvider, signInWithPopup } from 'firebase/auth';
import { Divider } from '@mui/material';
import MicrosoftIcon from '@mui/icons-material/AccountCircle'; // use your own MS icon if you prefer
import {
  Container,
  TextField,
  Button,
  Typography,
  Alert,
  Paper,
  Stack,
} from '@mui/material';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const logIn = async () => {
    try {
      await signInWithEmailAndPassword(getAuth(), email, password);
      navigate('/tools');
    } catch (e) {
      setError(e.message);
    }
  };

  // Login with Microsoft
  const loginWithMicorosoft = async () => {
    try{
      const auth = getAuth();
      const provider = new OAuthProvider('microsoft.com');
      // Lock to your tenant
      if(process.env.REACT_APP_AAD_TENANT_ID){
        provider.setCustomParameters({
          tenant: process.env.REACT_APP_AAD_TENANT_ID,
          prompt: 'select_account'
        });
      }else{
        // alternative: 'organizations' or 'common'
        provider.setCustomParameters({
          prompt: 'select_account'
      });
    }
    provider.addScope('User.Read');
    await signInWithPopup(auth, provider);
      navigate('/tools');
    } catch(e){
      setError(e.message);
    }
  }
  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Log In
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Stack spacing={2}>
          <TextField
            label="Email Address"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                logIn();
              }
            }}
            required
          />

          <TextField
            label="Password"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => {
              if(e.key === "Enter"){
                logIn();
              }
            }}
            required
          />

          <Button
            variant="contained"
            color="primary"
            onClick={logIn}
            fullWidth
          >
            Log In
          </Button>
          <Divider>OR</Divider>
          <Button
            variant="outlined"
            onClick={loginWithMicorosoft}
            startIcon={<MicrosoftIcon />}
            fullWidth
          >
            Login with Microsoft
          </Button>
        </Stack>

        <Typography variant="body2" sx={{ mt: 2 }}>
          Don't have an account?  <Link to="/create-account">Create one here</Link>
        </Typography>
        <br/>
        <Typography variant="body2" sx={{ mt: 1 }}>
          <Link to="/forgot-password">Forgot password?</Link>
        </Typography>
      </Paper>
    </Container>
  );
};

export default LoginPage;
